import { render, staticRenderFns } from "./ReActivateInputs.vue?vue&type=template&id=04dc3333&"
import script from "./ReActivateInputs.vue?vue&type=script&lang=js&"
export * from "./ReActivateInputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports